// Single source of truth for which backend the frontend talks to. Replaces
// VUE_APP_API_BASE_URL in .env.development/.env.production — those two files
// used to drift out of sync (both ended up pointing at production, which is
// what caused CSRF token mismatches when logging in from ccmis.test:3000).
export const API_BASE_URL =
  process.env.NODE_ENV === "production"
    ? "https://ccmis.api.chedcaraga.ph"
    : "http://ccmis.test:8000";
